export default "__VITE_ASSET__DY3uJy9b__"